module.exports = __webpack_public_path__ + "img/cover.ac76f440.png";